import {Component, Input} from '@angular/core';
import { AlertType } from '../../../core/components/alert/alert.component';

export enum Alignment {
    left,
    center,
    right
}

@Component({
    selector: 'app-output',
    templateUrl: './output.component.html',
    styleUrls: ['./output.component.scss']
})
export class OutputComponent {

    @Input() label: any;
    @Input() align: Alignment = Alignment.left;

    @Input() value: any;

    constructor() {
    }

    getAlignClass(align) {
        switch (align) {
            case Alignment.left:
                return '';
            case Alignment.center:
                return 'text-center';
            case Alignment.right:
                return 'text-right';

            default:
                return '';
        }
    }
}


